import { getVesselParticularsDocRef } from "../paths";
import { BaseFirestoreRepository } from "./BaseFirestoreRepository";

export class FirestoreVesselParticularsRepository extends BaseFirestoreRepository {
  async upsertEntity(entity, scope) {
    return this.upsert(
      getVesselParticularsDocRef(this.db, entity.vesselId),
      this.addStorageMarker({
        ...entity,
        organizationId: scope.organizationId,
      })
    );
  }

  async deleteEntity(_, scope) {
    return this.delete(getVesselParticularsDocRef(this.db, scope.vesselId));
  }
}
